import React from 'react';
import PropTypes from 'prop-types';
import css from './Edit.pcss';
import { AutoCompleteField } from '../../components/widgets';
import { FILTER_LABELS } from '../consts';

const ConditionNetwork = ({
    index,
    cIndex,
    filter,
    condition,
    metadata = {},
    editCondition,
    invalid = false,
    disabled = false,
}) => {
    const networkList = metadata?.networks || [];

    const selectedNetworks = (condition?.networks || [])
        .map(networkValue => networkList.find(option => option.value === networkValue))
        .filter(Boolean);

    const handleNetworksChange = networks => {
        editCondition(index, cIndex, 'networks', networks ? networks.map(network => network.value) : []);
    };

    return (
        <div className={css.condition}>
            <div className={css.networkFieldContainer}>
                <div className={css.networkLabel}>{FILTER_LABELS[filter.filter_type]}</div>
                <AutoCompleteField
                    value={selectedNetworks}
                    options={networkList}
                    isMulti
                    onChange={handleNetworksChange}
                    placeholder="Select Networks"
                    hasError={invalid && !(condition?.networks || []).length}
                    containerClass={css.networkSelectFullWidth}
                    disabled={disabled}
                />
            </div>
        </div>
    );
};

ConditionNetwork.propTypes = {
    index: PropTypes.number.isRequired,
    cIndex: PropTypes.number.isRequired,
    condition: PropTypes.object.isRequired,
    filter: PropTypes.object.isRequired,
    metadata: PropTypes.object,
    editCondition: PropTypes.func.isRequired,
    editFilter: PropTypes.func.isRequired,
    invalid: PropTypes.bool,
    disabled: PropTypes.bool,
};

export default ConditionNetwork;
